'use strict';
class RequestError extends Error {
   // constructor( c_message, c_file_name, n_line_number ) {
   //    // Needs to pass both `message` and `options` to install the "cause" property.
   //    super( c_message, c_file_name, n_line_number );
   // }// /constructor()
}// /class RequestError

export default RequestError;
